import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-state-section',
  templateUrl: './state-section.component.html',
})
export class StateSectionComponent {
  @Input() message: string = '';
  @Input() state: 'loading' | 'error' | 'empty' = 'empty';

  get icon(): string {
    switch (this.state) {
      case 'loading':
        return 'bi-arrow-clockwise';
      case 'error':
        return 'bi-exclamation-triangle';
      case 'empty':
        return 'bi-search';
      default:
        return '';
    }
  }
}
